import React from "react";

export default function WordingDivider({ text }) {
  return (
    <div className="mx-auto my-10 flex w-full max-w-[1200px] items-center justify-center px-4 md:my-14">
      <div className="h-px w-12 bg-white/15 sm:w-24" />
      <span className="mx-4 text-center text-[12px] font-semibold uppercase tracking-eyebrow text-white/90 sm:mx-6 sm:text-[14px]">
        {text}
      </span>
      <div className="h-px w-12 bg-white/15 sm:w-24" />
    </div>
  );
}
